import React from "react";
import {Font, Text, View, StyleSheet} from "@react-pdf/renderer";
import OpenSansRegular from "../../../../../statics/typos/openSansRegular.ttf";
import OpenSansSemiBold from "../../../../../statics/typos/openSansSemiBold.ttf";
import OpenSansBold from "../../../../../statics/typos/openSansBold.ttf";
import {OrderFilesUtils} from "../../../../../helpers/orderFilesUtils";

Font.register({
    family: "OpenSans",
    format: "truetype",
    src: OpenSansRegular
});
Font.register({
    family: "OpenSansSemiBold",
    format: "truetype",
    src: OpenSansSemiBold
});
Font.register({
    family: "OpenSansBold",
    format: "truetype",
    src: OpenSansBold
});

const styles = StyleSheet.create(OrderFilesUtils.styles);
const equipmentAndDamageStyles = StyleSheet.create(OrderFilesUtils.equipmentAndDamageStyles);
const legendStyle = StyleSheet.create({
    column: {
        width: "22%",
        minHeight: 25
    },
    smallColumn: {
        width: "6%",
        minHeight: 25
    },
    textCenterInColumn: {
        marginRight: "auto",
        marginLeft: "auto",
        fontFamily: "OpenSansBold"
    },
    image: {
        width: 100,
        height: 100
    }
});

export default function EquipmentAndDamagesLegend(): React.ReactElement {
    return (
        <View style={[styles.table, {width: "48%", height: "100%"}]}>
            <View style={styles.tableRow}>
                <View style={[styles.tableSmallCol, legendStyle.column, equipmentAndDamageStyles.tableHeaderColumn, {borderBottom: 1}]}>
                    <Text style={[styles.tableCellHeader, equipmentAndDamageStyles.tableHeaderText]}>
                        Equipment
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column, equipmentAndDamageStyles.tableHeaderColumn, {borderBottom: 1}]}>
                    <Text style={[styles.tableCellHeader, equipmentAndDamageStyles.tableHeaderText]}>
                        Wyposażenie
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn, equipmentAndDamageStyles.tableHeaderColumn, {borderBottom: 1}]}>
                    <Text style={[styles.tableCellHeader, equipmentAndDamageStyles.tableHeaderText, legendStyle.textCenterInColumn]}>
                        NR
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column, equipmentAndDamageStyles.tableHeaderColumn, {borderBottom: 1}]}>
                    <Text style={[styles.tableCellHeader, equipmentAndDamageStyles.tableHeaderText]}>
                        Damages
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column, equipmentAndDamageStyles.tableHeaderColumn, {borderBottom: 1}]}>
                    <Text style={[styles.tableCellHeader, equipmentAndDamageStyles.tableHeaderText]}>
                        Uszkodzenia
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn, equipmentAndDamageStyles.tableHeaderColumn, {borderBottom: 1}]}/>
            </View>
            <View style={styles.tableRow}>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={styles.tableCellHeader}>
                        Tarpaulin
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        Plandeka
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}>
                    <Text style={[styles.tableCellHeader, legendStyle.textCenterInColumn]}>
                        1
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        SCRATCHED
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        Obdrapany
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}>
                    <Text style={[styles.tableCellHeader, legendStyle.textCenterInColumn]}>
                        S
                    </Text>
                </View>
            </View>
            <View style={styles.tableRow}>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={styles.tableCellHeader}>
                        Side board
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        Burty
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}>
                    <Text style={[styles.tableCellHeader, legendStyle.textCenterInColumn]}>
                        2
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        BENT
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        Pogięty
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}>
                    <Text style={[styles.tableCellHeader, legendStyle.textCenterInColumn]}>
                        b
                    </Text>
                </View>
            </View>
            <View style={styles.tableRow}>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={styles.tableCellHeader}>
                        Chassis
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        Podwozie
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}>
                    <Text style={[styles.tableCellHeader, legendStyle.textCenterInColumn]}>
                        3
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        TORN
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        Podarty
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}>
                    <Text style={[styles.tableCellHeader, legendStyle.textCenterInColumn]}>
                        t
                    </Text>
                </View>
            </View>
            <View style={styles.tableRow}>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={styles.tableCellHeader}>
                        Legs
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        Nogi
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}>
                    <Text style={[styles.tableCellHeader, legendStyle.textCenterInColumn]}>
                        4
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        LEAKAGE
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        Wyciek
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}>
                    <Text style={[styles.tableCellHeader, legendStyle.textCenterInColumn]}>
                        Le
                    </Text>
                </View>
            </View>
            <View style={styles.tableRow}>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={styles.tableCellHeader}>
                        Wheels
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        Koła
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}>
                    <Text style={[styles.tableCellHeader, legendStyle.textCenterInColumn]}>
                        5
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        CRACKED
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        Rozbity
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}>
                    <Text style={[styles.tableCellHeader, legendStyle.textCenterInColumn]}>
                        Cr
                    </Text>
                </View>
            </View>
            <View style={styles.tableRow}>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={styles.tableCellHeader}>
                        Spare wheels
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        Koła zapasowe
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}>
                    <Text style={[styles.tableCellHeader, legendStyle.textCenterInColumn]}>
                        6
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        BROKEN
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        Połamany
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}>
                    <Text style={[styles.tableCellHeader, legendStyle.textCenterInColumn]}>
                        Br
                    </Text>
                </View>
            </View>
            <View style={styles.tableRow}>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={styles.tableCellHeader}>
                        Winch
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        Korba
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}>
                    <Text style={[styles.tableCellHeader, legendStyle.textCenterInColumn]}>
                        7
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        DENT
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        Wygięty
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}>
                    <Text style={[styles.tableCellHeader, legendStyle.textCenterInColumn]}>
                        D
                    </Text>
                </View>
            </View>
            <View style={styles.tableRow}>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={styles.tableCellHeader}>
                        Lights
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        Światła
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}>
                    <Text style={[styles.tableCellHeader, legendStyle.textCenterInColumn]}>
                        8
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        MISSING
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        Brak
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}>
                    <Text style={[styles.tableCellHeader, legendStyle.textCenterInColumn]}>
                        M
                    </Text>
                </View>
            </View>
            <View style={styles.tableRow}>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={styles.tableCellHeader}>
                        Seals
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        Plomby
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}>
                    <Text style={[styles.tableCellHeader, legendStyle.textCenterInColumn]}>
                        9
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        OUT OF ORDER
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        Uszkodzony
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}>
                    <Text style={[styles.tableCellHeader, legendStyle.textCenterInColumn]}>
                        O
                    </Text>
                </View>
            </View>
            <View style={styles.tableRow}>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={styles.tableCellHeader}>
                        Wedge
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        Kliny
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}>
                    <Text style={[styles.tableCellHeader, legendStyle.textCenterInColumn]}>
                        10
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}/>
                <View style={[styles.tableSmallCol, legendStyle.column]}/>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}/>
            </View>
            <View style={styles.tableRow}>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={styles.tableCellHeader}>
                        Agregat
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}>
                    <Text style={[styles.tableCellHeader]}>
                        Agregat
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}>
                    <Text style={[styles.tableCellHeader, legendStyle.textCenterInColumn]}>
                        11
                    </Text>
                </View>
                <View style={[styles.tableSmallCol, legendStyle.column]}/>
                <View style={[styles.tableSmallCol, legendStyle.column]}/>
                <View style={[styles.tableSmallCol, legendStyle.smallColumn]}/>
            </View>
        </View>
    );
}